import '../styles/notfound.scss'
import { Button, List, Space, Table, TableColumnsType , Typography } from "antd"
import { useNavigate } from "react-router-dom"
import { Main } from '../components/layout/Main'
import { BreadcrumbType, TeamType } from '../types/types'
import { useEffect, useState } from 'react'
import { WhatsAppOutlined } from '@ant-design/icons'
import api from '../services/api'
import { toast } from 'react-toastify'

const items: BreadcrumbType[] = [
    {
        title: 'Home'
    },
    {
        title: 'Meus Votantes',
    },
]

type VoterType = {
    ranking: string
    name: string
    count: string
}
export function Voter() {
    
    const [data, setData] = useState<VoterType[]>([])

    async function sendMessage(id: string){
        toast.success('Enviamos seus agradecimentos a: '+id)

    }
    useEffect(() => {
        async function loadData() {
            try {
                const response = await api.get('candidatas/listFans')
                setData(response.data)
            } catch (error) {
                console.error('Erro ao carregar dados do usuário:', error);
            }
        }
        loadData()
    }, [])
    const columns: TableColumnsType <VoterType> = [
        {
            title: 'Posição',
            dataIndex: 'ranking',
            key: 'ranking',
            render: (_, record) => (
                record.ranking+'º'
            )
            
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Votos',
            dataIndex: 'count',
            key: 'count',
        },
        {
            title: 'Ações',
            dataIndex: 'actions',
            key: 'actions',
            width: '150px',
            render: (_, record) => (
                <Button type="primary" onClick={()=>sendMessage(record.name)}>Enviar Agradecimento</Button>
            )
        },
    ]
    return (
        <Main itemBreadcrumb={items}>
            <div className='content-invoice'>
                <Space direction="vertical" >
                    <Typography.Title level={4}>
                        Meu Time
                    </Typography.Title>
                </Space>
                <Table dataSource={data} columns={columns} pagination={{pageSize:11, hideOnSinglePage:true}} style={{overflow:'auto'}} scroll={{ x: 'max-content' }}/>
            </div>
        </Main>
    )
}